import { NgModule } from '@angular/core';

import { TopBarNavComponent } from './top-bar-nav/top-bar-nav.component';

/**
 * Compatibility shell: TopBarNavComponent is standalone, this module only re exports it for
 * the NgModule based page apps. Import the component directly in standalone contexts.
 */
@NgModule({
    imports: [TopBarNavComponent],
    exports: [TopBarNavComponent],
})
export class NavigationModule {}
